import { inviteService } from '@/services/invites.service';

const initialState = () => ({
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  confirmEmail({ commit }, token) {
    commit('CONFIRM_EMAIL');
    return inviteService
      .confirmEmail(token)
      .then((response) => {
        commit('SUCCESS');
        return response;
      })
      .catch((error) => {
        commit('ERROR', error);
      });
  },
};

const mutations = {
  CONFIRM_EMAIL(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      error: error,
      pending: false,
      rejected: true,
    };
  },
};

const getters = {
  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const confirmEmail = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
